<template>
    <div id="app" class="right-to-left">
        <div class="loading-screen">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
            <strong class="mt-3">در حال بارگذاری</strong>
        </div>
        <router-view/>
    </div>
</template>

<script>
    import * as $ from "jquery";
    import EventBus from "./_framework/event-bus";
    export default {
        data() {
            return {
                isLoading: true
            }
        },
        mounted() {
            $(document).ready(() => {
                setTimeout(() => {
                    $(".loading-screen").remove();
                }, 1000)
            })
        },
        created() {
            if (this.$workbox) {
                this.$workbox.addEventListener("waiting", () => {
                    this.showUpgradeUI = true;
                });
            }
        },

        methods: {
            async accept() {
                this.showUpgradeUI = false
                await this.$workbox.messageSW({ type: "SKIP_WAITING" });
            }
        },

    }
</script>

<style lang="scss">
    @import '~vuejs-noty/dist/vuejs-noty.css';
    //@import "assets/styles/style.scss";

    .noty_body {
        text-align: right !important;
        font-family: 'Shabnam', Tahoma, sans-serif;
    }

    .noty_theme__metroui.noty_type__error {
        background-color: #f50057;
    }

    .noty_theme__metroui.noty_type__warning {
        background-color: #ffab00;
    }

    .noty_theme__metroui.noty_type__success {
        background-color: #00c853;
    }

    .noty_theme__metroui.noty_type__info, .noty_theme__metroui.noty_type__information {
        background-color: #00b0ff;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .1s ease;
    }

    .fade-enter, .fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .fade-long-enter-active, .fade-long-leave-active {
        transition: opacity .7s ease;
        transition-delay: 0.3s;
    }

    .fade-long-enter, .fade-long-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .loading-screen {
        height: 100vh;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999999;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .spinner {
        /*margin: 100px auto 0;*/
        width: 70px;
        text-align: center;
    }

    .spinner > div {
        width: 18px;
        height: 18px;
        background-color: #333;

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        } 40% {
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
          }
    }
</style>
